import axios from 'axios';
import { downloadExcelFile } from 'app/api/apiUtil';

const api = '/api/contracts/anniversary-contracts';

export const exportAnniversaryContractData = async (sort, direction, query) => {
  const response = await axios.get(`${api}/export?sort=${sort}&direction=${direction}&query=${query}&cacheBuster=${new Date().getTime()}`, {
    responseType: 'blob', // Important for downloading files
  });

  downloadExcelFile(response);
};
